// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__crZlz","badges":"styles_badges__2meXj"};